module.exports = __webpack_public_path__ + "img/DW365-137.a95c8612.jpg";